import Resource from './Resource';
class EasyBookingSettings extends Resource {
	constructor() {
		super('easyBooking');
	}
}
export default new EasyBookingSettings();
